import { useRef } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { AgGridReact } from "ag-grid-react";
import { Content_EQM2080_R01 } from "./Content_EQM2080_R01";
import { TableTab_EQM2080_R01 } from "./TableTab_EQM2080_R01";
import { defaultEQM2080_R01HeaderDto, EQM2080_R01DetailPivotDto } from "./Dto_EQM2080_R01";
import { Info_EQM2080_R01 } from "./Info_EQM2080_R01";
import { SearchSection_EQM2080_R01 } from "./SearchSection_EQM2080_R01";

export const Container_EQM2080_R01 = () => {
	const { tabList, setMessage } = useUiuxStore();

	const niDetailGridRef = useRef<AgGridReact<EQM2080_R01DetailPivotDto>>(null);
	const cnDetailGridRef = useRef<AgGridReact<EQM2080_R01DetailPivotDto>>(null);

	const {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		initContainerData,
		handleInsertClick,
		handleDeleteClick,
		handleSaveClick,
	} = Content_EQM2080_R01({
		tabList,
		setMessage,
		niDetailGridRef,
		cnDetailGridRef,
	});

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleInsertClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onPrintClick={handlePrintClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_EQM2080_R01 />
			<Info_EQM2080_R01 defaultEQM2080_R01HeaderRow={defaultEQM2080_R01HeaderDto} />
			<div className="flex flex-1 p-[12px] min-h-0">
				<TableTab_EQM2080_R01
					niGridRef={niDetailGridRef}
					cnGridRef={cnDetailGridRef}
				/>
			</div>
			<Message />
		</div>
	);
};
